import { arrayOf, bool, object, string } from 'prop-types';
import React from 'react';

import AsyncTable from '../../generic/Table/AsyncTable';
import { reactTableColumnShape } from '../../prop-types';
import api from '../../REST/api';
import dump from '../dump';
import ExportAllOpportunities from '../ExportAllOpportunities';

class List extends React.Component {
  state = {
    tableFilters: {},
  };

  setTableFilters = data => this.setState({ tableFilters: data });

  render() {
    const {
      columns,
      allColumns,
      searchParams,
      displayExportButton,
      storedName,
      ...rest
    } = this.props;
    const { tableFilters } = this.state;
    return (
      <AsyncTable
        className="select-table"
        keyField="id"
        allowSelection
        selectionName="opportunities"
        queryFn={({ search }) => {
          return api.getOpportunities({
            search: { ...searchParams, ...search },
          });
        }}
        allowFilterView
        columns={columns}
        allColumns={allColumns}
        storedName={storedName}
        onDownload={displayExportButton ? undefined : () => dump(searchParams)}
        minRows={2}
        setTableFilters={this.setTableFilters}
        {...rest}
      >
        {displayExportButton && (
          <ExportAllOpportunities
            exportParams={searchParams}
            tableFilters={tableFilters}
            className="ml-3"
          />
        )}
      </AsyncTable>
    );
  }
}

List.propTypes = {
  columns: arrayOf(reactTableColumnShape).isRequired,
  allColumns: arrayOf(reactTableColumnShape).isRequired,
  storedName: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  searchParams: object,
  displayExportButton: bool,
};

List.defaultProps = {
  searchParams: undefined,
  displayExportButton: false,
};

export default List;
